import EMPTY_FILTRO from './emptyFiltro'

const EMPTY_FILTRO_VISTORIA = (caixa) => {
  return {
    ...EMPTY_FILTRO(caixa),
    municipios: [],
    status: null,
    responsavel: null,
    orgao: null
  }
}

export default EMPTY_FILTRO_VISTORIA



// WEBPACK FOOTER //
// ./src/libs/models/filtro/emptyFiltroVistoria.js